// Imports
	//Icons
	import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
	import { faLandmark, faMoneyBill1Wave, faCreditCard } from "@fortawesome/free-solid-svg-icons"

	
// rafce
	const BannerPayment = () => {
		return (
			<div className="banner-payment">
				<div>
					<FontAwesomeIcon icon={ faLandmark } />
					<p>
						<strong>Transferencia bancaria</strong>
					</p>
				</div>
				<div>
					<FontAwesomeIcon icon={ faMoneyBill1Wave } />
					<p>
							<strong>10% off</strong><br />
							Por pago en efectivo
					</p>
				</div>
				<div>
					<FontAwesomeIcon icon={ faCreditCard } />
					<p>
							<strong>Todas las tarjetas</strong><br />
							Crédito y Débito
					</p>
				</div>
			</div>
		)
	}

export default BannerPayment
